import React, { useState } from 'react';
import { usePageHeader } from '../contexts/PageHeaderContext';
import PageHeader from '../components/PageHeader';
import FileUploader from '../components/FileUploader';
import ProcessingUploader from '../components/ProcessingUploader';
import { showToast } from '../utils/toast';

// Page Header configuration
const PAGE_HEADER_CONFIG = {
  breadcrumbs: [
    { label: 'Dashboard', path: '/' },
    { label: 'File Upload' }
  ],
  title: 'File Upload & Processing',
  icon: '📄',
  description: 'Upload your documents and let AI analyze them with advanced processing.',
};

const TemplateFileUpload = () => {
  usePageHeader(PAGE_HEADER_CONFIG);

  const [uploadedFile, setUploadedFile] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [processingComplete, setProcessingComplete] = useState(false);

  // Handle file selection
  const handleFileSelect = (file) => {
    setUploadedFile(file);
    showToast(`File "${file.name}" selected`, 'success');
  };

  // Handle continue from upload
  const handleContinue = (file) => {
    setUploadedFile(file);
    setIsProcessing(true);
    showToast('Starting file processing...', 'info');
  };

  // Handle cancel
  const handleCancel = () => {
    setUploadedFile(null);
    setIsProcessing(false);
    setProcessingComplete(false);
  };

  // Handle processing complete
  const handleProcessingComplete = () => {
    setProcessingComplete(true);
    showToast('File processing completed!', 'success');
  };

  // Handle continue after processing
  const handleProcessingContinue = () => {
    showToast('Redirecting to results...', 'info');
    // In real app, navigate to results page
    setTimeout(() => {
      setUploadedFile(null);
      setIsProcessing(false);
      setProcessingComplete(false);
      showToast('Ready for next upload', 'success');
    }, 1000);
  };

  // Handle back from processing
  const handleProcessingBack = () => {
    setIsProcessing(false);
    setProcessingComplete(false);
  };

  return (
    <div className="space-y-6">
      <PageHeader {...PAGE_HEADER_CONFIG} />
      
      {!isProcessing ? (
        // Upload interface
        <FileUploader
          accept=".pdf,.doc,.docx,.txt"
          maxSize={50 * 1024 * 1024}
          title="Drag & drop your document here"
          subtitle="or click to browse"
          browseButtonText="Browse Files"
          changeButtonText="Change File"
          requirements={[
            { label: 'Formats: PDF, DOC, DOCX, TXT' },
            { label: 'Max size: 50 MB' },
            { label: 'Supported: English documents' },
          ]}
          onFileSelect={handleFileSelect}
          onContinue={handleContinue}
          onCancel={handleCancel}
          showActions={true}
        />
      ) : (
        // Processing interface
        <ProcessingUploader
          file={uploadedFile}
          pageCount={uploadedFile ? Math.floor(Math.random() * 50) + 10 : 24}
          uploadTime="just now"
          onComplete={handleProcessingComplete}
          onBack={handleProcessingBack}
          onContinue={handleProcessingContinue}
          showActions={true}
        />
      )}
    </div>
  );
};

export default TemplateFileUpload;
